import { CancellablePromise } from "real-cancellable-promise";
import { searchApi } from "common/api/search";
import { findSite } from "common/functions/sites";
import { Context } from "common/types/context";
import { Site } from "common/types/sites";
import { getParentSites } from "x/account-settings/sites/functions";
import { Entity } from "common/entities/types";
import { behaveAs, getEntityByBehavior } from "common/entities";

type SiteObject = {
  site: string;
};

export const fetchAssociatedSites = (
  { apiCall, entities }: Context,
  entity: Entity,
  taskId: string,
): CancellablePromise<SiteObject[]> =>
  behaveAs("Task", entity)
    ? (searchApi(apiCall).runQueryForSite(
        {
          entity: getEntityByBehavior("ScheduledEvent", entities).name,
          query: {
            select: [{ name: "site" }],
            filter: { name: "taskId", op: "eq", value: taskId },
          },
        },
        "all",
      ) as CancellablePromise<SiteObject[]>)
    : CancellablePromise.resolve([]);

export const getWarningMessage = () =>
  _(
    "Task associated with one or more scheduled work orders. Site can not be deselected",
  );

export const getSitesWithParents = (
  contextSites: Site[],
  sites: string[],
): string[] => {
  const allSiteNames = sites.flatMap((site) => {
    const found = findSite(site, contextSites);
    const parentSites = found
      ? getParentSites(found, contextSites).map((parent) => parent.name)
      : [];
    return [site, ...parentSites];
  });
  return Array.from(new Set(allSiteNames));
};
